module.exports = __webpack_public_path__ + "static/media/btn3.efeda46e.jpg";